import { BannerStatus, InlineAlertType } from '@varo/graphql-schema-types';

const mapAlertType = (type?: BannerStatus): InlineAlertType => {
  switch (type) {
    case BannerStatus.Negative:
      return InlineAlertType.Error;

    case BannerStatus.Positive:
    default:
      return InlineAlertType.Success;
  }
};

export { mapAlertType };
